module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/signme dark-vector-a9b5c10d3fb0085f95f828d8fd6e37f5.svg";